export interface PromptData {
  topic: string;
  goal: string;
  industry: string;
  audience: string;
  tone: string;
  complexity: string;
  format: string;
}

export const INDUSTRIES = [
  'Marketing',
  'Education',
  'Healthcare',
  'Technology',
  'Finance',
  'Retail',
  'Manufacturing',
  'Other'
] as const;

export const TONES = [
  'Professional',
  'Casual',
  'Academic',
  'Conversational',
  'Technical',
  'Persuasive'
] as const;

export const COMPLEXITY_LEVELS = [
  'Beginner',
  'Intermediate',
  'Advanced',
  'Expert'
] as const;

export const OUTPUT_FORMATS = [
  'Step-by-step guide',
  'Bullet points',
  'Detailed explanation',
  'Executive summary',
  'Q&A format',
  'Tutorial'
] as const;

export type Industry = typeof INDUSTRIES[number];
export type Tone = typeof TONES[number];
export type ComplexityLevel = typeof COMPLEXITY_LEVELS[number];
export type OutputFormat = typeof OUTPUT_FORMATS[number];